import { Link } from "react-router-dom";
import type { AppNotification } from "@/api/types";
import { cn } from "@/lib/cn";
import { timeAgo } from "@/lib/dates";
import { CATEGORY_META, FALLBACK } from "./meta";

/** One row in the bell dropdown or the notifications page. */
export function NotificationItem({
  note,
  onOpen,
  compact = false,
}: {
  note: AppNotification;
  onOpen?: (note: AppNotification) => void;
  compact?: boolean;
}) {
  const meta = CATEGORY_META[note.category] ?? FALLBACK;
  const Icon = meta.icon;
  const body = (
    <>
      <span className={cn("mt-0.5 grid size-9 shrink-0 place-items-center rounded-full bg-fg/[0.05]", meta.tone)} aria-hidden>
        <Icon className="size-4" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-start justify-between gap-2">
          <span className={cn("text-sm", note.is_read ? "text-ink-soft" : "font-medium text-ink")}>{note.title}</span>
          {!note.is_read && <span className="mt-1.5 size-2 shrink-0 rounded-full bg-cyan shadow-glow-cyan" aria-label="Unread" />}
        </span>
        {note.body && <span className={cn("mt-0.5 block text-sm text-ink-muted", compact && "line-clamp-2")}>{note.body}</span>}
        <span className="mt-1 block text-xs text-ink-muted">
          {meta.label} · {timeAgo(note.created_at)}
        </span>
      </span>
    </>
  );
  const cls = "flex w-full gap-3 rounded-input px-3 py-3 text-left transition hover:bg-fg/[0.04]";
  return note.link ? (
    <Link to={note.link} className={cls} onClick={() => onOpen?.(note)}>
      {body}
    </Link>
  ) : (
    <button type="button" className={cls} onClick={() => onOpen?.(note)}>
      {body}
    </button>
  );
}
